/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 輸液速度
 */
export type TreatmentInfusionRateEnum =
  (typeof TreatmentInfusionRateEnum)[keyof typeof TreatmentInfusionRateEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentInfusionRateEnum = {
  RAPID: 'RAPID',
  MAINTENANCE: 'MAINTENANCE',
} as const;
